import { TransactionListItem } from "@common/schemas/transaction.schema";

export interface SplitSiblings {
    hasTopSibling: boolean;
    hasBottomSibling: boolean;
}

/**
 * Calculate split sibling relationships for a transaction at a given index
 */
export function calculateSplitSiblings(
    transaction: TransactionListItem,
    index: number,
    allTransactions: TransactionListItem[],
): SplitSiblings {
    if (!transaction.splitParentId) {
        return { hasTopSibling: false, hasBottomSibling: false };
    }

    const hasTopSibling =
        index > 0 &&
        allTransactions[index - 1].splitParentId === transaction.splitParentId;

    const hasBottomSibling =
        index < allTransactions.length - 1 &&
        allTransactions[index + 1].splitParentId === transaction.splitParentId;

    return { hasTopSibling, hasBottomSibling };
}
